define(["jquery", "@modules/tools/geocoder", "bootstrap"], function ($, geocoder) {
    var querystring = require("querystring");
    if ($("form[name=seminar-search-form]").length > 0) {
        $("#Sort").change(function () {
            $("form[name=seminar-search-form]").submit();
        });

        $(document).ready(function () {
            var query = querystring.parse();
            var seminarType = query["SeminarType"];
            $(".lookup-tools-container > .inperson").hide();
            if (seminarType === "Virtual" || seminarType == undefined) {
                $('.nav-tabs a[href="#county"]').tab("show");
                $("#SeminarType").val("Virtual");
            } else {
                $('.nav-tabs a[href="#zipcode"]').tab("show");
                $("#SeminarType").val("InPerson");
            }

            $('.nav-tabs a[href="#county"]').on("click", function (e) {
                $(".lookup-tools-container > .virtual").show();
                $(".lookup-tools-container > .inperson").hide();
            });

            $('.nav-tabs a[href="#zipcode"]').on("click", function (e) {
                $(".lookup-tools-container > .virtual").hide();
                $(".lookup-tools-container > .inperson").show();
            });
        });

        $('a[data-bs-toggle="tab"]').on("shown.bs.tab", function (e) {
            var target = $(e.target).attr("href");
            if (target == "#county") {
                $("#SeminarType").val("Virtual");
            } else {
                $("#SeminarType").val("InPerson");
            }
        });

        $("form[name=seminar-search-form]").submit(function (e) {
            e.preventDefault();
            var zipOrAddress = $("#SeminarQuery").val().trim();
            var prevzipOrAddress = $("#PreviousSeminarQuery").val().trim();

            $("#seminarSearchListingSubmit").attr("data-zipcode", zipOrAddress);

            if (zipOrAddress && zipOrAddress !== prevzipOrAddress) {
                geocoder.geocode(zipOrAddress).then(function (coordinates) {
                    if (coordinates) {
                        $("#Latitude").val(coordinates.lat);
                        $("#Longitude").val(coordinates.lng);
                    } else {
                        $("#Latitude").val("");
                        $("#Longitude").val("");
                    }
                    // there is no point in repeatedly geo-coding the same information
                    $("#PreviousSeminarQuery").val(zipOrAddress);

                    $(e.target).unbind("submit").trigger("submit");
                });
            } else {
                $(e.target).unbind("submit").trigger("submit");
            }
        });

        if ($("#SeminarQuery").val().trim() && !$("#PreviousSeminarQuery").val().trim()) {
            console.log("submitting " + $("#SeminarQuery").val().trim());
            $("form[name=seminar-search-form]").submit();
        }

        if ($(".noResultsForZipCode").length > 0) {
            var dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: "noSeminarResults"
            });
        }
    }

    // seminar listing on county pages
    if ($("form[name=seminar-by-county-search-form]").length > 0) {
        $(document).ready(function () {
            setSeminarFilterDropdown();

            var query = querystring.parse();
            var seminarType = query["SeminarType"];
            var county = query["County"];

            if (seminarType != undefined || seminarType == "" || county != undefined || county == "") {
                location.hash = "#seminars";
            }
        });
        $("#SeminarType").change(function () {
            $("form[name=seminar-by-county-search-form]").submit();
        });
    }

    // seminar listing on rep pages
    if ($("form[name=seminar-by-sales-rep-search-form]").length > 0) {
        $(document).ready(function () {
            setSeminarFilterDropdown();
            var query = querystring.parse();
            var seminarType = query["SeminarType"];

            if (seminarType != undefined || seminarType == "") {
                location.hash = "#seminars";
            }
        });
        $("#SeminarType").change(function () {
            $("form[name=seminar-by-sales-rep-search-form").submit();
        });
    }

    function setSeminarFilterDropdown() {
        var query = querystring.parse();
        var seminarType = query["SeminarType"];
        if (seminarType === "" || seminarType == undefined) {
            $("#SeminarType").val("");
        } else {
            $("#SeminarType").val(seminarType);
        }
    }
});
